export default __webpack_public_path__ + "static/reactive-icon.28c215f51b1c09851b098b9c222b0f85.svg";